<template>
  <div :class="classes">
    <wt-paged-table :on-request-data="getDepositSettlementList" :total-size="totalNumber" :page-size="pageSize" ref="table" isAddPageToRouter
    :isOutside="isOutside" layout="total,sizes, prev, pager, next,jumper" :pageSizes="[10, 20, 50, 200]">
     <wt-table   ref="tables" :list="tableData" :labels="tableLabels">
        <template>
          <slot/>
        </template>
     </wt-table>
    </wt-paged-table>
  </div>
</template>

<script>
// 组件class前缀
const prefixCls = 'pt-scan-payment-table'

export default {
  name: 'pt-scan-payment-table',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  props: {
    totalNumber: {
      type: Number,
      default: 0
    },
    isOutside: {
      type: Boolean,
      default: false
    },
    pageSize: {
      type: Number,
      default: 10
    },
    tableData: {
      type: Array,
      default: function () {
        return []
      }
    },
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  methods: {
    getDepositSettlementList (page, next, size) {
      this.$emit('getDepositSettlementList', page, next, size)
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
